/**
 * Link
 */
export const GOOGLE_CALENDAR_LINK = `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=20220911T010000Z%2F20220911T080000Z&text=Arin+%26+Miftah+Wedding&details=Arin+%26+Miftah+Wedding`;
export const GOOGLE_MAPS_LINK = `https://goo.gl/maps/kfFTBJKwRhw3qWut8`;

/**
 * Wedding time
 */
export const EPOCH_START_EVENT = 1662858000;
export const EPOCH_END_EVENT = 1662858000;
export const UTC_WEDDING_TIME = '2022-09-11:04:00:00Z';
